<template>
  <div id="app">
    <transition-page>
      <router-view/>
    </transition-page>
  </div>
</template>

<script>
import TransitionPage from './components/transitions/TransitionPage.vue';
export default {
  name: 'App',
  components: {
    TransitionPage
  }
}
</script>

<style>
  *{margin:0;padding:0;font-family:"黑体",Microsoft YaHei,Arial, Helvetica, sans-serif, "宋体";list-style:none;font-weight:normal;font-size:.28rem;-webkit-tap-highlight-color: rgba(0,0,0,0);}
  body{margin:0 auto;padding:0 auto;}
  a{text-decoration:none;}
  img{border:none;}
  ul{padding:0;margin:0;}
  li{ list-style:none;}
  .hide{display:none;}
  .clear{clear:both;width:0;height:0;}
</style>



// WEBPACK FOOTER //
// src/App.vue